module.exports = __webpack_public_path__ + "static/media/sdk-5.3c3cc227.svg";